import CachedIcon from "@mui/icons-material/Cached";

export const reloadParent = {
  label: "Hard Reload",
  icon: <CachedIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></CachedIcon>,
};
